import BaseComponent from "../../../../baseComponent.js";
import InternalEvent from "../../../../../core/constants/internalEvent.js";
import ColorUtil from "../../../../../core/utils/colorUtil.js";
import styles from "./styles.scss";

export default class CompositeLegend extends BaseComponent {
  constructor(props) {
    super(props);
    this.subscribe('stale_data_check', payload => this.checkStaleData(payload));
    this.isStale = false;
  }

  handleClick(event) {
    if (event.target == this.refs.editIcon) {
      // this.props.renderLegendController(this.props.widgetId, this.props.legends)
      this.publish('openLegendConfig', {
        widgetId: this.props.widgetId,
        legends: this.props.legends
      });
    } else {

      this.publish(InternalEvent.Dashboard.CHART_LEGEND_CLICKED, {
        widgetId: this.props.widgetId,
        legends: this.props.legends
      });
    }
  }

  handleMouseEnter() {
    this.publish(InternalEvent.Dashboard.CHART_LEGEND_HOVERED, {
      widgetId: this.props.widgetId,
      legends: this.props.legends
    });
  }

  handleMouseLeave() {
    this.publish(InternalEvent.Dashboard.CHART_LEGEND_HOVERED, {
      widgetId: this.props.widgetId,
      legends: []
    });
  }

  checkStaleData(payload) {
    if (payload.widgetId === this.props.widgetId && payload.legendId === this.props.legends[0].id) {
      if (payload.isStale && !this.isStale) {
        $(this.refs.label).css("text-decoration", "line-through");
        this.isStale = true;
      }

      if (!payload.isStale && this.isStale) {
        $(this.refs.label).css("text-decoration", "none");
        this.isStale = false;
      }
    }
  }


  render() {
    let bgColor = ColorUtil.toRgba(this.props.legends[0].parameters.legendColor,
      this.props.legends[0].parameters.chartTypeParameters.fillOpacity);
    let borderColor = this.props.legends[0].parameters.legendColor;

    if (!this.props.legends[1].parameters.isActive){
      bgColor = "#fff";
      borderColor = "grey";
    }

    let colorStyle = {
      float: 'left',
      width: '11px',
      height: '11px',
      background: bgColor,
      border: "1px solid " + borderColor,
      borderRadius: "10px",
      marginTop: "1px"
    };

    let style = {};
    if (!this.props.legends[1].parameters.isActive) style["opacity"] = "0.5";

    let secondLabel;
    if (this.props.legends[1].parameters.legendLabel.length > 0) {
      secondLabel = " - " + this.props.evalLegendLabel(this.props.legends[1].parameters.legendLabel);
    }
    return (
      <div className={styles.legend} style={style}
           onMouseEnter={() => this.handleMouseEnter()}
           onMouseLeave={() => this.handleMouseLeave()} onClick={this.handleClick}>
        <div ref="legendEditContainer" style={{zIndex: 11000}}/>
        <div style={colorStyle}/>
        <div className={styles.label} ref="label">
          {this.props.evalLegendLabel(this.props.legends[0].parameters.legendLabel)}{secondLabel}
        </div>
        <i className="icon-note" ref="editIcon"/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/legend/compositeLegend.jsx